import { defineComponent } from 'vue';
import ListFilterPopover from '@/components/root-component/list-filter-popover/list-filter-popover.vue';
import { storeToRefs } from 'pinia';
import { useMgaReportRealMoneyBalanceListStore } from '@/store/mga-real-money-balance/mga-real-money-balance.store';
import {
  useMgaRealMoneyBalanceListFilterStore,
} from '@/store/mga-real-money-balance/mga-real-money-balance-list-filter.store';
import {
  GROUP_BY_OPTIONS,
  MgaRealMoneyBalanceListFilterFields,
} from '@/models/mga-real-money-balance/mga-real-money-balance-list-filter.model';

export default defineComponent({
  name: 'MgaRealMoneyBalancePageListFilter',

  components: { ListFilterPopover },

  setup() {
    const mgaReportRealMoneyBalanceListStore = useMgaReportRealMoneyBalanceListStore();
    const { isRealMoneyBalancePlayerListLoading } = storeToRefs(mgaReportRealMoneyBalanceListStore);

    const mgaRealMoneyBalanceListFilterStore = useMgaRealMoneyBalanceListFilterStore();
    const {
      isFilterVisible,
      activeFiltersCount,
      filterFormData,
      isFilterActive,
    } = storeToRefs(mgaRealMoneyBalanceListFilterStore);
    const { submitFilter, resetFilter, toggleFilterVisibility } = mgaRealMoneyBalanceListFilterStore;

    return {
      isFilterVisible,
      isRealMoneyBalancePlayerListLoading,
      toggleFilterVisibility,
      GROUP_BY_OPTIONS,
      MgaRealMoneyBalanceListFilterFields,
      filterFormData,
      activeFiltersCount,
      submitFilter,
      resetFilter,
      isFilterActive,
    };
  },
});
